import React, {useState, useEffect} from "react";
import Toast from "../../../lib/toast";
import { getAllBranches, getBranchCount, uploadMediaRecord } from "../../../features/gyms/helper/api";
import { isAuthenticated } from "../../../auth";
import { startLoader, stopLoader } from "../../../lib/utils";
// import config from "../../../config";
import client from "../../../clients";
import { useRef } from "react";
import _ from 'lodash'

const ManageAds = (props) => {

  const contentObj = {
    image: "",
    title: "",
    kioskAssign: false, 
  };


  const [isUpdateToPublishRecord,setUpdateToPublishRecord] = useState(false);
  const isGlobalAds=useRef(false);
  const mediaRecord = useRef(null)
  const [isEditOperationActive,setEditOperationActive]=useState(false);
  const [Branches,setBranches]=useState([])
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [isButtonLock,setButtonLock]=useState(false);
  const [selectedBranches,setSelectedBranches] = useState([]);
  const [isSelectedBranchListOpen, setSelectedBranchListOpen] = useState(true);
  const [newMediaRecords,setNewMediaRecords]=useState([]);
  const [Branch,setBranch] = useState('');
  const [isAdsTypeOpen, setAdsTypeOpen] = useState(false);
  const [adsType, setAdsType] = useState("Splash Content");
  const [videoLink, setVideoLink] = useState('');
  const [currentInputField, setCurrentInputField] = useState('');
  const [startBranchLoader,setStartBranchLoader]=useState(false)
  var [pageNo,setPageNo]=useState({
    branch:1
  })
  const pageSize = {
    branch:20
  }
  var [pageCount,setPageCount]=useState({
    branch:1
  })
  var [total,setTotal] = useState({
    branch:1
  });
  const [branchSearchKey,setBranchSearchKey] = useState('');
  const {user,token} = isAuthenticated();


  const handleScrollBranch = async event => {
    const { offsetHeight, scrollTop, scrollHeight } = event.target;
    if (offsetHeight + scrollTop === scrollHeight && pageNo.branch < pageCount.branch) {
      pageNo.branch = pageNo.branch + 1;
      setPageNo(pageNo)
      setStartBranchLoader(true)
      await GetBranches();
      setStartBranchLoader(false)
    }
  }

  const handleBranchSearchKey = event =>{
    setBranchSearchKey(event.target.value);
  }

  const handleSearchBranch = event =>{
    setBranchSearchKey(event.target.value)
  }

  const UploadMediaRecord = async event =>{
    try{
      setButtonLock(true)
      await startLoader()
      const formData = new FormData();

      newMediaRecords.forEach((data,index)=>{
        formData.append("files", data.file);
      })

      let mediaRecordJson = newMediaRecords.map(d=>({
        name:d.title,
        fileType:d.image?"image":"video",
        isLink:false,
        isMainScreenBanner:adsType == "Splash Content"? false: true,
        isActive:d.kioskAssign
      }))



      formData.set("mediaRecordPayloads",JSON.stringify(mediaRecordJson))
      formData.set("isMainScreenBanner",adsType == "Splash Content"? false: true);
      formData.set("isAdminAds",isGlobalAds.current);
      if(isGlobalAds.current){
        formData.set("branchIDs",selectedBranches.map(d=>d._id));
      }

      let response = await uploadMediaRecord(user._id,token,isGlobalAds.current?null:Branch._id,formData);

      if(!response.error){
        new Toast({
          type:"success",
          duration:3000,
          message:"Media record published successfully"
        })
      }else{
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }

      props.toggleCreateContent(true)
    
    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:JSON.stringify(error)
      })
    }
    setButtonLock(false)
    await stopLoader()
  }

  const handleSelectBranch = branch => {
    const copys = [...selectedBranches];
    let foundIndex = copys.findIndex(d=>d._id == branch._id);
    if(foundIndex == -1){
      copys.push(branch)
    }else{
      copys.splice(foundIndex,1);
    }
    setSelectedBranches(copys);
    if(isGlobalAds.current && props.handleBranchIDs) props.handleBranchIDs(copys.map(d=>d._id))
  }

  const toggleInputFields = (value, type) => event => {
    if(type == "data"){
      setCurrentInputField(value)
    }else{  
      setCurrentIndex(value);
      if (event) {
        let interval = setInterval(() => {
          let element = document.querySelector('#' + "title-" +value);
          if (element) {
            element.focus();
            clearInterval(interval)
          }
        }, 0);
      }
    }
  }


  const handleChange = (index) => async event => {
    // value = !value ? event.target.value : value;
    newMediaRecords[index].title = event.target.value;
    setNewMediaRecords([
      ...newMediaRecords
    ]);
  }

  const toggleActiveInactiveButton = (index) => {

    setNewMediaRecords(oldstate=>{
      oldstate[index].kioskAssign=newMediaRecords[index].kioskAssign?false:true;
      return [...oldstate]
    })
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
        if(newMediaRecords.length < client.config.maxFileUpload){
          const reader = new FileReader();
          reader.onloadend = () => { 
            let testObj = (file.type.includes("zip") && adsType == "Splash Content") ? {
              ...contentObj,
              zip : reader.result,
              file: file
            }:{
              ...contentObj,
              image: reader.result,
              file: file
            }
            if(!(file.type.includes("zip") && adsType != "Splash Content")){
              setNewMediaRecords([
                ...newMediaRecords,
                testObj
              ])  
            }
            
          };
          reader.readAsDataURL(file);
        }else{
          new Toast({
            duration:3000,
            type:"info",
            message:"Upload limit exceeded. Maximum allowed is 8 files."
          })
        }    
    }else{
      new Toast({
        duration:3000,
        type:"info",
        message:"File not selected"
      })
    }
  };



  const toggleSelectedBranchList = () => {
    setSelectedBranchListOpen(!isSelectedBranchListOpen);
  }


  const handleDeleteContent = (indexToDelete) => {
    setNewMediaRecords(newMediaRecords.filter((_, index) => index !== indexToDelete));
  }

  const handleVideoLink = (event) => {
    setVideoLink(event.target.value)
  }

  const handleAddVideoLink = () => {
    setNewMediaRecords([{
      type: "link",
      link : videoLink
    },...newMediaRecords]);
  }
 

  const toggleDropdown = () => {
    setAdsTypeOpen(!isAdsTypeOpen);
  }

  const handleSelectedContentType = (data) => {
    setAdsType(data);
  }

  const GetBranchParams = () =>{
    const params = {
      pageNo:pageNo.branch,
      pageSize:pageSize.branch,
      haveKioskDevice:true
    };
    if(branchSearchKey) params.q = branchSearchKey;
    return params;
  }

  const GetBranches=async (isReload)=>{
    try{
      const params = GetBranchParams();
      const response = await getAllBranches(user._id,token,params);
      if(response.error){

      }else{
        if(isReload) setBranches(response);
        else setBranches([...Branches,...response]);
      }
    }catch(error){
      console.error(error)
    }
    setStartBranchLoader(false)
  }

  const GetBranchCount=async (isReload)=>{
    try{
      const params = GetBranchParams();
      delete params.pageNo
      delete params.pageSize
      const response = await getBranchCount(user._id,token,params);
      if(response.error){

      }else{
        pageNo.branch = 1;
        setPageNo({
          ...pageNo
        })
        pageCount.branch = Math.ceil(response.COUNT / pageSize.branch);
        setPageCount({
          ...pageCount
        })
        total.branch = response.COUNT;
        setTotal({
          ...total
        })
      }
    }catch(error){
      console.error(error)
    }
  }

  useEffect(() => {
    if(!mediaRecord.current){
      mediaRecord.current=props.mediaRecord?props.mediaRecord:null;
      if(props.mediaRecord){
        const branchList=[...mediaRecord.current.branch,...mediaRecord.current.branches];
        setSelectedBranches(branchList);
        if(props.handleBranchIDs) props.handleBranchIDs(branchList.map(d=>d._id));
      }
    }
    isGlobalAds.current = props.isGlobalAds?true:false;
    setUpdateToPublishRecord(props.isUpdateToPublishRecord?true:false);
    setEditOperationActive(props.isEditOperationActive?true:false);
    setBranch(props.branch?props.branch:"");
    if(props.currentAdsType){
      setAdsType(props.currentAdsType == 'banner'?'Banner Content':'Splash Content')
    }
  },[props])

  useEffect(async ()=>{
    if(isGlobalAds.current){
      setStartBranchLoader(true)
      await GetBranchCount()
      await GetBranches(true)
    }
  },[isGlobalAds.current,branchSearchKey])



  return(
    <div className="global-modal-container d-flex">
      <div className="branch-content-modal-add flex-item">
       <div className="d-flex w-full space-between" style={{background: "#DEF3FF", padding:"12px", borderRadius: "16px 16px 0 0"}}>
          <div className='d-flex'>
            <svg className='flex-item m-r-8' width="30" height="30" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.99999 9.22877L11.9851 14.5555L12.0386 14.6518C12.3356 15.1696 12.7901 15.5727 13.3321 15.7988C13.8741 16.0249 14.4734 16.0616 15.0376 15.9031C15.6018 15.7445 16.0996 15.3997 16.4543 14.9217C16.8089 14.4437 17.0007 13.8591 17 13.258C17.0017 12.7765 16.8789 12.3032 16.6443 11.8864L16.6149 11.8371L11.4287 2.61027V2.60761C10.7656 1.42053 10.0805 1 8.99999 1C8.54109 0.999637 8.08989 1.12116 7.69015 1.35277C7.29042 1.58439 6.95572 1.91823 6.71853 2.32193L6.64644 2.45101C6.44571 2.83562 6.33347 3.27567 6.33347 3.74012C6.33236 4.18108 6.43515 4.61577 6.63306 5.00704L6.65162 5.04297L6.72674 5.17205L8.99999 9.22877ZM8.99999 9.22877L6.00971 14.5666M6.00971 14.5666C6.21562 14.1762 6.33347 13.7309 6.33347 13.258C6.33354 12.6641 6.14543 12.0862 5.79825 11.6114C5.45108 11.1366 4.9632 10.7905 4.40807 10.6253C3.85294 10.4601 3.26059 10.4846 2.72021 10.6953C2.17983 10.9059 1.72066 11.2912 1.41183 11.7932M6.00971 14.5666L5.96179 14.6544C5.72588 15.0641 5.39012 15.4036 4.98762 15.6393C4.58512 15.875 4.12979 15.9988 3.66652 15.9985C3.31626 15.9987 2.96941 15.9279 2.64579 15.7903C2.32216 15.6526 2.02812 15.4507 1.78047 15.1962C1.53282 14.9417 1.33643 14.6395 1.20251 14.3069C1.06859 13.9743 0.999774 13.6179 1 13.258C1 12.7966 1.10965 12.3619 1.30779 11.9804L1.40924 11.7985L1.41183 11.7932M1.41183 11.7932L6.64644 2.45057" stroke="var(--darkBlue)" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p className="flex-item modal-header-text">{isEditOperationActive?"Edit content":isUpdateToPublishRecord?"Selected content(s) "+props.selectedContentCount:"Create Ads"}</p>
          </div>
          <div onClick={()=> props.toggleCreateAds()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
            <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
            </svg>
          </div>
        </div>
        <div className="branch-content-inner-container" style={isUpdateToPublishRecord?{padding:"12px"}:{padding:"12px"}}>
          {!isUpdateToPublishRecord && <div onClick={()=>toggleDropdown()} className={`${adsType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: adsType ? "1px solid var(--darkBlue)" : "" }}>
            <p className="placeholder-txt flex-item" style={{ fontSize: adsType ? "10px" : "14px", color: adsType ? "var(--darkBlue)" : "", transition: "180ms"}}>Content Type</p>
            <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
              <svg className="flex-item" style={{ transform: isAdsTypeOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
              </svg>
            </div>
            <input id="unit-type" className={`${adsType ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Unit" value={adsType} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
            {
              isAdsTypeOpen && (
                <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                  <div onClick={()=>handleSelectedContentType("Banner Ads")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Banner Ads</p>
                  </div>
                  <div onClick={()=>handleSelectedContentType("Splash Ads")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Vertical Ads</p>
                  </div>
                  <div onClick={()=>handleSelectedContentType("Tv Ads")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Tv Ads</p>
                  </div>
                </div>
              )
            }
          </div>}

          {!isUpdateToPublishRecord && <div className="branch-content-scroll-container flex-item">
            {
              newMediaRecords.length > 0 && newMediaRecords.map((data, index) => {
                if(data.type == "link"){
                  return(
                    <div className="d-flex space-between">
                      <div className={`${data.link ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12 m-t-8`} style={{ border: data.link ? "1px solid var(--darkBlue)" : "", width:"90%" }}>
                        <p className="placeholder-txt flex-item" style={{ fontSize: data.link ? "10px" : "14px", color: currentInputField == "video-link" || data.link ? "var(--darkBlue)" : "", transition: "180ms"}}>Link {index + 1}</p>
                        <input className={`${data.link ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Link" value={data.link} />
                      </div>
                      <div onClick={() => handleDeleteContent(index)} className="d-flex global-round-btn flex-item" style={{background:"#ffffff", boxShadow:"0px 0px 4px rgba(0, 0, 0, 0.25)"}}>
                        <svg className="fill-svg flex-item" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.616 20C7.168 20 6.78667 19.8427 6.472 19.528C6.15733 19.2133 6 18.8323 6 18.385V6H5V5H9V4.23H15V5H19V6H18V18.385C18 18.845 17.846 19.2293 17.538 19.538C17.23 19.8467 16.8453 20.0007 16.384 20H7.616ZM17 6H7V18.385C7 18.5643 7.05767 18.7117 7.173 18.827C7.28833 18.9423 7.436 19 7.616 19H16.385C16.5383 19 16.6793 18.936 16.808 18.808C16.9367 18.68 17.0007 18.5387 17 18.384V6ZM9.808 17H10.808V8H9.808V17ZM13.192 17H14.192V8H13.192V17Z" fill="black"/>
                        </svg>
                      </div>
                    </div>
                  )
                }else{
                  return(
                  <div className="branch-content-details d-flex space-between m-b-20">
                    <div className="image-section">
                       {
                        data.zip?(
                          <svg style={{marginTop:8}} width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 12V10H18V12H16ZM16 14H14V12H16V14ZM16 16V14H18V16H16ZM11.194 8L9.194 6H4.615C4.43567 6 4.28834 6.05767 4.173 6.173C4.05767 6.28833 4 6.436 4 6.616V17.385C4 17.5643 4.05767 17.7117 4.173 17.827C4.28834 17.9423 4.436 18 4.616 18H14V16H16V18H19.385C19.5643 18 19.7117 17.9423 19.827 17.827C19.9423 17.7117 20 17.5643 20 17.385V8.615C20 8.43567 19.9423 8.28833 19.827 8.173C19.7117 8.05767 19.5643 8 19.385 8H16V10H14V8H11.194ZM4.615 19C4.155 19 3.77067 18.846 3.462 18.538C3.15334 18.23 2.99934 17.8453 3 17.384V6.616C3 6.15533 3.15434 5.771 3.463 5.463C3.77167 5.155 4.15567 5.00067 4.615 5H9.596L11.596 7H19.385C19.845 7 20.2293 7.15433 20.538 7.463C20.8467 7.77167 21.0007 8.156 21 8.616V17.385C21 17.845 20.846 18.2293 20.538 18.538C20.23 18.8467 19.8457 19.0007 19.385 19H4.615Z" fill="black"/>
                          </svg>
                        ):(
                          <img src={data.image} />
                        )
                       }
                    </div>
                    <div className="flex-item" style={{width:"70%"}}>
                      <div onClick={toggleInputFields(index)} className={`${currentIndex == index || data.title ? "member-global-input-field m-b-12" : "member-global-input-field m-b-12 d-flex"}`} style={{ border: currentIndex == index || data.title ? "1px solid var(--darkBlue)" : "", height:"120px" }}>
                        <div className="d-flex m-t-4" style={{alignSelf:"flex-start"}}>
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentIndex === "name" || data.title ? "10px" : "14px", color: currentIndex == index || data.title ? "var(--darkBlue)" : "", transition: "180ms" }}>Content Name</p>
                        </div>
                        <textarea id={"title-" + index} value={data.title} style={{width:"100%", height: "100px"}} onChange={handleChange(index)} className={`${currentIndex == index || data.title ? "active-input-field" : "inactive-input-field"}`} type="text" />
                      </div>
                      <div className="d-flex space-between">
                        <div className="d-flex">
                          <p className="flex-item fs-16 m-r-8">Assign in Kiosk</p>
                          <div onClick={() => toggleActiveInactiveButton(index)} className='flex-item d-flex active-inactive-button m-r-12' style={{ background: !data.kioskAssign ? "rgba(255, 0, 85, 0.347)" : "" }}>
                            <div className='active-inactive-ball flex-item' style={{ background: !data.kioskAssign ? "rgb(201, 0, 57)" : "", margin: !data.kioskAssign ? "0 0 0 0" : "" }} />
                          </div>
                        </div>
                        <div onClick={()=> handleDeleteContent(index)} className="d-flex delete-container cursor-pointer">
                          <svg className="svg-fill flex-item margin-auto" width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.68171 10C1.39371 10 1.14857 9.90023 0.946286 9.7007C0.744 9.50116 0.642857 9.25956 0.642857 8.9759V1.12238H0V0.488269H2.57143V0H6.42857V0.488269H9V1.12238H8.35714V8.9759C8.35714 9.2676 8.25814 9.51131 8.06014 9.70704C7.86214 9.90277 7.61486 10.0004 7.31829 10H1.68171ZM7.71429 1.12238H1.28571V8.9759C1.28571 9.08962 1.32279 9.18305 1.39693 9.25618C1.47107 9.32932 1.566 9.36588 1.68171 9.36588H7.31893C7.4175 9.36588 7.50814 9.3253 7.59086 9.24413C7.67357 9.16297 7.71471 9.07335 7.71429 8.97527V1.12238ZM3.09086 8.09765H3.73371V2.39061H3.09086V8.09765ZM5.26629 8.09765H5.90914V2.39061H5.26629V8.09765Z" fill="black"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  )
                }
              })
            }

            {
              newMediaRecords.length<8 && [
                <div className="d-flex m-t-6 m-b-6" style={{width:"100%", height: "1px", background:"#e0e0e0"}} />,
                // <div className="d-flex space-between">
                //   <div onClick={toggleInputFields("video-link", "data")} className={`${currentInputField == "video-link" || videoLink ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12 m-t-16`} style={{ border: currentInputField == "video-link" || videoLink ? "1px solid var(--darkBlue)" : "", width:"90%" }}>
                //     <p className="placeholder-txt flex-item" style={{ fontSize: currentInputField == "video-link" || videoLink ? "10px" : "14px", color: currentInputField == "video-link" || videoLink ? "var(--darkBlue)" : "", transition: "180ms"}}>Video Link</p>
                //     <input onChange={handleVideoLink} className={`${currentInputField == "video-link" || videoLink ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Link" value={videoLink} />
                //   </div>
                //   <div onClick={()=> handleAddVideoLink()} className="d-flex global-round-btn flex-item" style={{background:"#ffffff", boxShadow:"0px 0px 4px rgba(0, 0, 0, 0.25)"}}>
                //     <svg className="stroke-svg flex-item" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                //       <path d="M6 12H18M12 18V6" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                //     </svg>
                //   </div>
                // </div>,
                <div className="content-drag-drop-container">
                  <div className="d-flex content-info cursor-pointer">
                    <input onChange={handleImageChange} className="cursor-pointer" style={{width:"100%", height:"100%", position:"absolute", zIndex: 2}} type="file" accept="image/*,application/zip,.zip" />
                    <div className="d-flex flex-item margin-auto">
                      <svg className="flex-item m-r-20" width="89" height="89" viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.541 11.125H66.7494C69.6999 11.125 72.5296 12.2971 74.6159 14.3834C76.7023 16.4698 77.8744 19.2995 77.8744 22.25V70.4583C77.8744 73.4089 76.7023 76.2386 74.6159 78.3249C72.5296 80.4112 69.6999 81.5833 66.7494 81.5833H18.541C15.5905 81.5833 12.7608 80.4112 10.6745 78.3249C8.58811 76.2386 7.41602 73.4089 7.41602 70.4583V22.25C7.41602 19.2995 8.58811 16.4698 10.6745 14.3834C12.7608 12.2971 15.5905 11.125 18.541 11.125ZM18.541 14.8333C16.574 14.8333 14.6875 15.6147 13.2966 17.0056C11.9057 18.3965 11.1243 20.283 11.1243 22.25V65.2296L27.0331 49.2838L36.3039 58.5546L54.8456 40.0129L74.166 59.3333V22.25C74.166 20.283 73.3846 18.3965 71.9937 17.0056C70.6028 15.6147 68.7164 14.8333 66.7494 14.8333H18.541ZM36.3039 63.8204L27.0331 54.5496L11.1243 70.4583C11.1243 72.4254 11.9057 74.3118 13.2966 75.7027C14.6875 77.0936 16.574 77.875 18.541 77.875H66.7494C68.7164 77.875 70.6028 77.0936 71.9937 75.7027C73.3846 74.3118 74.166 72.4254 74.166 70.4583V64.5621L54.8456 45.2788L36.3039 63.8204ZM27.8118 22.25C30.2706 22.25 32.6287 23.2267 34.3673 24.9654C36.1059 26.704 37.0827 29.0621 37.0827 31.5208C37.0827 33.9796 36.1059 36.3377 34.3673 38.0763C32.6287 39.8149 30.2706 40.7917 27.8118 40.7917C25.3531 40.7917 22.995 39.8149 21.2564 38.0763C19.5178 36.3377 18.541 33.9796 18.541 31.5208C18.541 29.0621 19.5178 26.704 21.2564 24.9654C22.995 23.2267 25.3531 22.25 27.8118 22.25ZM27.8118 25.9583C26.3366 25.9583 24.9217 26.5444 23.8786 27.5876C22.8354 28.6307 22.2493 30.0456 22.2493 31.5208C22.2493 32.9961 22.8354 34.4109 23.8786 35.4541C24.9217 36.4973 26.3366 37.0833 27.8118 37.0833C29.2871 37.0833 30.702 36.4973 31.7451 35.4541C32.7883 34.4109 33.3743 32.9961 33.3743 31.5208C33.3743 30.0456 32.7883 28.6307 31.7451 27.5876C30.702 26.5444 29.2871 25.9583 27.8118 25.9583Z" fill="#BABABA"/>
                      </svg>
                      <div className="flex-item" style={{textAlign:"center"}}>
                        <p className="fs-16">{adsType == "Splash Content" ? "1080 (W) X 1920 (H)" : "820 (W) X 312 (H)"}</p>
                        <p className="fs-16">Upload {(adsType != "Splash Content")?"Image":"Image / Zip"}</p>
                      </div>
                    </div>
                  </div>
                  <svg width="100%" height="100%" viewBox="0 0 359 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="358" height="119" rx="11.5" fill="#F7F7F7" stroke="#B6B2B2" stroke-dasharray="12 12"/>
                  </svg>
                </div>
              ]
            }

            {
              isGlobalAds.current && (
                <div className="w-full m-t-8">
                  <div onClick={()=>toggleSelectedBranchList()} className="d-flex space-between cursor-pointer">
                    <div className="d-flex">
                      <p className="m-r-8 fs-16 font-weight-700 flex-item">Selected Branch(s)</p>
                      <div className="d-flex count-container flex-item">
                        <p className="margin-auto font-weight-600">{selectedBranches.length}</p>
                      </div>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 16px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: isSelectedBranchListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="18" height="18" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                  </div>
                  {
                    isSelectedBranchListOpen && (
                      <div className="d-flex-wrap m-t-12 p-b-12" style={{maxHeight:200, overflowY:'auto'}}>
                        {
                          selectedBranches.map(data=>{
                            return (
                              <div className="d-flex m-r-12 m-b-12 branch-container">
                                {
                                  data.gym[0].logoFileID ?
                                      <div className='gym-logo flex-item m-r-8 d-flex'>
                                          <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.gym[0].logoFileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                                      </div>
                                      : <div className="gym-logo m-r-8 flex-item d-flex" style={{
                                          backgroundColor: data.gym[0].logoPlaceholderColor ? data.gym[0].logoPlaceholderColor : "#5d883c"
                                      }}>
                                          <p className='flex-item' style={{
                                              color: "#ffffff",
                                              margin: "0 auto",
                                              fontSize: 14,
                                          }}>{`${data.gym[0].name}`.trim()[0]}</p>
                                      </div>
                              }
                                {/* <div className='gym-logo flex-item m-r-8 d-flex' style={{ backgroundColor: "#5d883c" }}>
                                  <p className='flex-item' style={{  color: "#ffffff", margin: "0 auto", fontSize: 14 }}>{data.name.trim()[0]}</p>
                                </div> */}
                                <p className="flex-item">{data.name} , {data.address} ({data.gym[0].name})</p>
                              </div>
                            )
                          })
                        }
                      </div>
                    )
                  }
                  <div id="search-container" className="global-search-box d-flex m-r-12 w-full m-t-12" style={{border:"1px solid #9a9a9a"}}>
                    <svg className="flex-item" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_7199_1513)">
                      <path d="M11.7429 10.3441C12.7112 9.02279 13.1449 7.38459 12.9572 5.75725C12.7695 4.12991 11.9743 2.63344 10.7307 1.56723C9.48701 0.501022 7.88665 -0.0562959 6.24973 0.00677721C4.61282 0.0698504 3.06008 0.748663 1.90217 1.90741C0.744249 3.06615 0.0665484 4.61938 0.00464653 6.25633C-0.0572553 7.89329 0.501207 9.49326 1.56831 10.7361C2.6354 11.979 4.13244 12.7732 5.75992 12.9597C7.38739 13.1462 9.02528 12.7113 10.3459 11.7421H10.3449C10.3749 11.7821 10.4069 11.8201 10.4429 11.8571L14.2929 15.7071C14.4804 15.8947 14.7348 16.0002 15 16.0003C15.2653 16.0004 15.5198 15.8951 15.7074 15.7076C15.895 15.5201 16.0005 15.2657 16.0006 15.0005C16.0007 14.7352 15.8954 14.4807 15.7079 14.2931L11.8579 10.4431C11.8221 10.4069 11.7837 10.3735 11.7429 10.3431V10.3441ZM12.0009 6.5001C12.0009 7.22237 11.8586 7.93757 11.5822 8.60486C11.3058 9.27215 10.9007 9.87847 10.39 10.3892C9.87926 10.8999 9.27295 11.305 8.60566 11.5814C7.93837 11.8578 7.22317 12.0001 6.5009 12.0001C5.77863 12.0001 5.06343 11.8578 4.39614 11.5814C3.72885 11.305 3.12253 10.8999 2.61181 10.3892C2.10109 9.87847 1.69596 9.27215 1.41956 8.60486C1.14316 7.93757 1.0009 7.22237 1.0009 6.5001C1.0009 5.04141 1.58036 3.64246 2.61181 2.61101C3.64326 1.57956 5.04221 1.0001 6.5009 1.0001C7.95959 1.0001 9.35854 1.57956 10.39 2.61101C11.4214 3.64246 12.0009 5.04141 12.0009 6.5001V6.5001Z" fill="#6D6D6D"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_7199_1513">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <input onInput={_.debounce(handleBranchSearchKey,700)} type="text" placeholder="Search Branch By Name" className="flex-item" style={{width:"95%"}}/>
                  </div>
                  <div className="apk-branch-list m-t-16" onScroll={handleScrollBranch} style={{maxHeight:200,overflowY:'auto',marginBottom:20}}>
                    {
                      Branches.map(data=>{
                        return (
                          <div className="d-flex m-b-12" >
                            <input  onClick={()=> handleSelectBranch(data)} checked={selectedBranches.findIndex(d=>d._id == data._id) !=-1} className='flex-item m-r-12 cursor-pointer m-r-12' name='branch-apk-checkbox' type='checkbox'/>
                            <div className="d-flex">
                              {
                                  data.gym[0].logoFileID ?
                                    <div className='gym-logo flex-item m-r-8 d-flex'>
                                        <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.gym[0].logoFileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                                    </div>
                                    : 
                                    <div className="gym-logo m-r-8 flex-item d-flex" style={{
                                        backgroundColor: data.gym[0].logoPlaceholderColor ? data.gym[0].logoPlaceholderColor : "#5d883c"
                                    }}>
                                        <p className='flex-item' style={{
                                            color: "#ffffff",
                                            margin: "0 auto",
                                            fontSize: 14,
                                        }}>{`${data.gym[0].name}`.trim()[0]}</p>
                                    </div>
                              }
                              <p className="flex-item">{data.name} , {data.address} ({data.gym[0].name})</p>
                            </div>
                          </div>
                        )
                      })
                    }
                    {startBranchLoader && <div className="loader-5 center"><span></span></div>}
                  </div>
                </div>
              )
            }

          </div>}

            {
              isUpdateToPublishRecord && (
                <div className="branch-content-scroll-container flex-item" style={{height:'90%', paddingTop: '0px'}}>
                  <div onClick={()=>toggleSelectedBranchList()} className="d-flex space-between cursor-pointer">
                    <div className="d-flex">
                      <p className="m-r-8 fs-16 font-weight-600 flex-item">Selected Branch(s)</p>
                      <div className="d-flex count-container flex-item">
                        <p className="margin-auto font-weight-600">{selectedBranches.length}</p>
                      </div>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 16px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: isSelectedBranchListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="18" height="18" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                  </div>
                  {
                    isSelectedBranchListOpen && (
                      <div className="d-flex-wrap m-t-12 p-b-12" style={{height:'60%', overflowY:'auto'}}>
                        {
                          selectedBranches.map(data=>{
                            return (
                              <div className="d-flex m-r-12 m-b-16 branch-container space-between w-full">
                                <div className="d-flex" style={{width:"90%"}}>
                                  {
                                    data.gym[0].logoFileID ?
                                        <div className='gym-logo m-r-8 d-flex' style={{alignSelf:"flex-start"}}>
                                            <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.gym[0].logoFileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                                        </div>
                                        : <div className="gym-logo m-r-8 d-flex" style={{
                                            backgroundColor: data.gym[0].logoPlaceholderColor ? data.gym[0].logoPlaceholderColor : "#5d883c", alignSelf:"flex-start"}}>
                                            <p className='flex-item' style={{
                                                color: "#ffffff",
                                                margin: "0 auto",
                                                fontSize: 14,
                                            }}>{`${data.gym[0].name}`.trim()[0]}</p>
                                        </div>
                                  }
                                  {/* <div className='gym-logo flex-item m-r-8 d-flex' style={{ backgroundColor: "#5d883c" }}>
                                    <p className='flex-item' style={{  color: "#ffffff", margin: "0 auto", fontSize: 14 }}>{data.name.trim()[0]}</p>
                                  </div> */}
                                  <div className="d-flex space-between" style={{width:"80%"}}>
                                    <p style={{width:"96%"}}>{data.name} , {data.address} ({data.gym[0].name})</p>
                                    <div className="m-t-8" style={{width:"8px", height:"8px", borderRadius:"100%", background:(data.activeDevice && data.activeDevice.length)?"#5d883c":"#9a9a9a"}} />
                                  </div>
                                </div>
                                {/* TODO */}
                                <div onClick={()=>handleSelectBranch(data)} className="controller-btn controller-btn-red d-flex m-l-8 m-r-12 bg-red" style={{borderRadius:"100%", width:"24px", height:"24px"}}>
                                  <svg className="flex-item margin-auto" width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.44202 11.6665C4.18068 11.6665 3.95824 11.5747 3.77468 11.3911C3.59113 11.2076 3.49935 10.9853 3.49935 10.7244V3.49979H2.91602V2.91645H5.24935V2.46729H8.74935V2.91645H11.0827V3.49979H10.4993V10.7244C10.4993 10.9927 10.4095 11.2169 10.2298 11.397C10.0502 11.577 9.82579 11.6668 9.55668 11.6665H4.44202ZM9.91602 3.49979H4.08268V10.7244C4.08268 10.829 4.11632 10.9149 4.1836 10.9822C4.25088 11.0495 4.33702 11.0831 4.44202 11.0831H9.55727C9.64671 11.0831 9.72896 11.0458 9.80402 10.9711C9.87907 10.8965 9.9164 10.814 9.91602 10.7238V3.49979ZM5.72068 9.91645H6.30402V4.66645H5.72068V9.91645ZM7.69468 9.91645H8.27802V4.66645H7.69468V9.91645Z" fill="#FFFFFF"/>
                                  </svg>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    )
                  }
                  <div className="m-t-12 m-b-12" style={{width:"100%", height: "1px", background:"#e0e0e0"}} />
                  <p className="flex-item m-b-8 fs-16 font-weight-700">Add Device</p>
                  <div id="search-container" className="global-search-box d-flex m-r-12 w-full m-t-12" style={{border:"1px solid #9a9a9a"}}>
                    <svg className="flex-item" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_7199_1513)">
                      <path d="M11.7429 10.3441C12.7112 9.02279 13.1449 7.38459 12.9572 5.75725C12.7695 4.12991 11.9743 2.63344 10.7307 1.56723C9.48701 0.501022 7.88665 -0.0562959 6.24973 0.00677721C4.61282 0.0698504 3.06008 0.748663 1.90217 1.90741C0.744249 3.06615 0.0665484 4.61938 0.00464653 6.25633C-0.0572553 7.89329 0.501207 9.49326 1.56831 10.7361C2.6354 11.979 4.13244 12.7732 5.75992 12.9597C7.38739 13.1462 9.02528 12.7113 10.3459 11.7421H10.3449C10.3749 11.7821 10.4069 11.8201 10.4429 11.8571L14.2929 15.7071C14.4804 15.8947 14.7348 16.0002 15 16.0003C15.2653 16.0004 15.5198 15.8951 15.7074 15.7076C15.895 15.5201 16.0005 15.2657 16.0006 15.0005C16.0007 14.7352 15.8954 14.4807 15.7079 14.2931L11.8579 10.4431C11.8221 10.4069 11.7837 10.3735 11.7429 10.3431V10.3441ZM12.0009 6.5001C12.0009 7.22237 11.8586 7.93757 11.5822 8.60486C11.3058 9.27215 10.9007 9.87847 10.39 10.3892C9.87926 10.8999 9.27295 11.305 8.60566 11.5814C7.93837 11.8578 7.22317 12.0001 6.5009 12.0001C5.77863 12.0001 5.06343 11.8578 4.39614 11.5814C3.72885 11.305 3.12253 10.8999 2.61181 10.3892C2.10109 9.87847 1.69596 9.27215 1.41956 8.60486C1.14316 7.93757 1.0009 7.22237 1.0009 6.5001C1.0009 5.04141 1.58036 3.64246 2.61181 2.61101C3.64326 1.57956 5.04221 1.0001 6.5009 1.0001C7.95959 1.0001 9.35854 1.57956 10.39 2.61101C11.4214 3.64246 12.0009 5.04141 12.0009 6.5001V6.5001Z" fill="#6D6D6D"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_7199_1513">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <input onInput={_.debounce(handleBranchSearchKey,700)} type="text" placeholder="Search Branch By Name" className="flex-item" style={{width:"95%"}}/>
                  </div>
                  <div className="apk-branch-list m-t-16" onScroll={handleScrollBranch} style={{maxHeight:'80%',overflowY:'auto',marginBottom:20}}>
                    {
                      Branches.map(data=>{
                        return (
                          <div className="d-flex m-b-12" >
                            <input  onClick={()=> handleSelectBranch(data)} checked={selectedBranches.findIndex(d=>d._id == data._id) !=-1} className='flex-item m-r-12 cursor-pointer m-r-12' name='branch-apk-checkbox' type='checkbox'/>
                            <div className="d-flex">
                              {
                                  data.gym[0].logoFileID ?
                                    <div className='gym-logo flex-item m-r-8 d-flex'>
                                        <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.gym[0].logoFileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                                    </div>
                                    : 
                                    <div className="gym-logo m-r-8 flex-item d-flex" style={{
                                        backgroundColor: data.gym[0].logoPlaceholderColor ? data.gym[0].logoPlaceholderColor : "#5d883c"
                                    }}>
                                        <p className='flex-item' style={{
                                            color: "#ffffff",
                                            margin: "0 auto",
                                            fontSize: 14,
                                        }}>{`${data.gym[0].name}`.trim()[0]}</p>
                                    </div>
                              }
                              <p className="flex-item">{data.name} , {data.address} ({data.gym[0].name})</p>
                            </div>
                          </div>
                        )
                      })
                    }
                    {startBranchLoader && <div className="loader-5 center"><span></span></div>}
                  </div>
                </div>
              )
            }
            {
              isUpdateToPublishRecord?(
                  <div onClick={isButtonLock?null:props.publishMediarecord} className={`member-button-global ${isButtonLock && 'member-button-global-inactive'} btn-center d-flex m-t-20`}>
                    <p className='flex-item'>{isEditOperationActive?"Save":"Publish"}</p>
                  </div>
              ):(
                <div onClick={isButtonLock?null:UploadMediaRecord} className={`member-button-global ${isButtonLock && 'member-button-global-inactive'} btn-center d-flex m-t-20`}>
                  <p className='flex-item'>Upload Content(s)</p>
                </div>
              )
            }
        </div>
      </div>
    </div>
  )
}

export default ManageAds;